// Lesson normalization: the renderer speaks one shape (v3 segments+blocks,
// see memory/LESSON_SPEC.md). Lessons stored before the block language carry
// sections with body+checks; convert those on the fly so every stored lesson
// renders through the same path — including mixed arrays, where a regenerated
// v3 segment sits inside an old sections list.

const entryToSegment = (sec, i) => {
  if (Array.isArray(sec.blocks)) {
    return { concept: sec.title, hook: "", mapLabel: "", ...sec, id: sec.id || `g${i + 1}` };
  }
  const checks = Array.isArray(sec.checks) ? sec.checks : sec.check ? [sec.check] : [];
  return {
    id: sec.id || `s${i + 1}`,
    title: sec.heading || "",
    hook: sec.hook || "",
    mapLabel: sec.mapLabel || "",
    concept: sec.concept || sec.heading || "",
    blocks: [
      ...(sec.body ? [{ t: "prose", md: sec.body }] : []),
      ...checks.map((w) => ({ t: "check", widget: w })),
    ],
  };
};

export function normalizeLesson(lesson) {
  if (!lesson) return null;
  const entries = lesson.segments || lesson.sections || [];
  return {
    ...lesson,
    keyTakeaways: Array.isArray(lesson.keyTakeaways) ? lesson.keyTakeaways : [],
    segments: entries.map(entryToSegment),
  };
}

// Read-aloud text for a segment: hook + prose, with highlight markup reduced
// to the bare term.
export function segmentSpeech(seg) {
  const prose = seg.blocks
    .filter((b) => b.t === "prose")
    .map((b) => b.md.replace(/\[\[([^\]|]+)\|[^\]|]+\|[^\]]+\]\]/g, "$1"))
    .join(" ");
  return `${seg.title}. ${seg.hook ? seg.hook + " " : ""}${prose}`;
}
